module.exports = __webpack_public_path__ + "img/seo_gsport_item04.8a1a45c.webp";